var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRisk24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_RiskManagement",
    d: "M937.993,343.92H924.169a2.046,2.046,0,0,1-2.089-2,1.937,1.937,0,0,1,.26-.965l6.911-12a2.142,2.142,0,0,1,2.841-.782,2.044,2.044,0,0,1,.817.782l6.911,12a1.957,1.957,0,0,1-.822,2.718,2.167,2.167,0,0,1-1.007.248Zm-6.912-4.033a1.009,1.009,0,1,0,1.045,1.016v-.01A1.028,1.028,0,0,0,931.081,339.887Zm0-8.064a1.024,1.024,0,0,0-1.045,1v5.056a1.046,1.046,0,0,0,2.09,0v-5.056A1.023,1.023,0,0,0,931.081,331.823Z",
    transform: "translate(-922.08 -327.92)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRisk24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_risk24x24.fc29aa4f5e7c1d10bc6a335d9890bdaf.svg";